import { render } from "./ControlButtonGroup.vue?vue&type=template&id=314ebb4a"
import script from "./ControlButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ControlButtonGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script